import { store } from '@/context/store';

import { getUrl } from '../fetch';

import { IMotorStock } from './IMotorStock';

export async function getStockNumber(
    stock?: string
): Promise<IMotorStock | null> {
    const state = store.getState();

    let stockNumber = stock;
    if (!stockNumber) {
        stockNumber = state.borrowerReducer.vehicle.stockNumber;
    }
    const stockIntegration = state.displayReducer.stockIntegration;
    console.log('stockIntegration', stockIntegration);
    let url = '';
    if (stockIntegration === undefined) {
        url = `/api/iMotor/stockNumber/${stockNumber}`;
    }else{
        url = `/api/${stockIntegration.toUpperCase()}/${stockNumber}`;
    }
    

    const response = await getUrl<any>(url);

    return response.data;
}
